/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_BackpressureInputs */

const en_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backpressure`)
};

const ar_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الضغط الرجعي`)
};

const bn_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকপ্রেশার`)
};

const de_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegendruck`)
};

const es_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrapresión`)
};

const fr_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contre-pression`)
};

const pt_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrapressão`)
};

const zh_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`背压`)
};

const tr_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karşı basınç`)
};

const ru_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Противодавление`)
};

const pl_svchip_backpressure = /** @type {(inputs: Svchip_BackpressureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeciwciśnienie`)
};

/**
* | output |
* | --- |
* | "Backpressure" |
*
* @param {Svchip_BackpressureInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_backpressure = /** @type {((inputs?: Svchip_BackpressureInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_BackpressureInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_backpressure(inputs)
	if (locale === "bn") return bn_svchip_backpressure(inputs)
	if (locale === "de") return de_svchip_backpressure(inputs)
	if (locale === "es") return es_svchip_backpressure(inputs)
	if (locale === "fr") return fr_svchip_backpressure(inputs)
	if (locale === "pt") return pt_svchip_backpressure(inputs)
	if (locale === "zh") return zh_svchip_backpressure(inputs)
	if (locale === "tr") return tr_svchip_backpressure(inputs)
	if (locale === "ru") return ru_svchip_backpressure(inputs)
	if (locale === "pl") return pl_svchip_backpressure(inputs)
	return en_svchip_backpressure(inputs)
});